<template>
  <div class="flex h-screen flex-row bg-gray-100 dark:bg-gray-900 dark:text-white relative">
    <Sidebar :open="sidebarOpen" :mobile="isMobile" @toggleSidebar="toggleSidebar" />
    <!-- Overlay en mobile -->
    <div v-if="isMobile && sidebarOpen" class="fixed inset-0 bg-black/50 z-30" @click="toggleSidebar"></div>
    <div class="flex flex-col flex-1 min-w-0 z-10">
      <Header @toggleSidebar="toggleSidebar" />
      <main class="overflow-auto flex-1 transition-all duration-200 bg-gray-100 dark:bg-gray-900 dark:text-white">
        <div v-if="breadcrumb" class="px-4 pt-3 pb-1">
          <div class="text-[10px] text-gray-500 dark:text-gray-400 font-semibold uppercase tracking-wider">{{ breadcrumb }}</div>
        </div>
        <router-view />
      </main>
      <Footer />
    </div>
    <!-- Herramienta: Cotizador de Papel -->
    <CotizadorPapel />
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Header from './Header.vue';
import Sidebar from './Sidebar.vue';
import Footer from './Footer.vue';
import CotizadorPapel from './Herramientas/CotizadorPapel.vue';
import { useUserStore } from '@/stores/user';
import Swal from 'sweetalert2';

const userStore = useUserStore();
const router = useRouter();

const sidebarOpen = ref(true);
const isMobile = ref(false);

function handleResize() {
  isMobile.value = window.innerWidth < 768;
  if (isMobile.value) sidebarOpen.value = false;
  else sidebarOpen.value = true;
}
function toggleSidebar() {
  sidebarOpen.value = !sidebarOpen.value;
}
onMounted(() => {
  handleResize();
  window.addEventListener('resize', handleResize);
});
onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

const route = useRoute();
const breadcrumb = computed(() => {
  const map = {
    '/dashboard': 'Dashboard',
    '/analytics': 'Analíticas',
    '/products': 'Lista de Productos',
    '/profile': 'Perfil de Usuario',
    '/clientes': 'Catálogo de Clientes',
  };
  return map[route.path] || '';
});

</script> 